var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('p',[_vm._v(_vm._s(_vm.test))])])
}
var staticRenderFns = []

export { render, staticRenderFns }